module.exports = "//static.hsappstatic.net/LoginUI/static-1.13324/img/ms-logo.png"